module.exports = __webpack_public_path__ + "static/services-software-development-b2fde9012b7adedf0f2e0d4042328d89.svg";